import { cx } from "class-variance-authority"
import { memo } from "react"

import { ProcedureStepCompletionStatus } from "../../enums/procedures"
import { procedureStepCompletionStatusData } from "../../mappings/procedures"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuIconWithWrapper, type LuIconWithWrapperProps } from "./LuIconWithWrapper"
import type { IconsProps } from "./typings"

interface ProcedureStepCompletionStatusIconProps extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	status: ProcedureStepCompletionStatus
}

export const ProcedureStepCompletionStatusIcon = memo<ProcedureStepCompletionStatusIconProps>((props) => {
	const { ref, status, ...rest } = props

	const { color, icon } = procedureStepCompletionStatusData[status]

	return <LuIconWithWrapper ref={ref} color={color} icon={icon} {...rest} />
})
ProcedureStepCompletionStatusIcon.displayName = "ProcedureStepCompletionStatusIcon"

interface ProcedureStepCompletionStatusIconsProps extends IconsProps {
	statuses: ProcedureStepCompletionStatus[]
}

export const ProcedureStepCompletionStatusIcons = memo<ProcedureStepCompletionStatusIconsProps>((props) => {
	const { ref, className, statuses, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{statuses.slice(0, max ?? statuses.length).map((status, index) => (
				<ProcedureStepCompletionStatusIcon status={status} key={`${status}-${index}`} background />
			))}
		</span>
	)
})
ProcedureStepCompletionStatusIcons.displayName = "ProcedureStepCompletionStatusIcons"
